import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@maui/elements'
import { useAppHost } from '@maui-mf/common-react'

const ValidateButton = ({ techniqueId }) => {
  const host = useAppHost('MA_MSV')

  if (!host) {
    return null
  }

  const path = `manage_sims/actions?techniques=${encodeURIComponent(techniqueId)}`
  const href = host + path

  return (
    <Button as="a" href={href} rel='noopener noreferrer' target='_blank'>
      Validate
    </Button>
  )
}

ValidateButton.propTypes = {
  techniqueId: PropTypes.number,
}

export default ValidateButton
